module.exports = "/images/mr.svg?26ca3fe5d01ef062efe751bcfe487431";